"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.engine = exports.Engine = exports.update = void 0;
var engine_db_1 = __importDefault(require("@verified/c11-engine.db"));
var module_1 = require("./module");
var updateListeners = [];
var update = function (config) {
    updateListeners.forEach(function (x) {
        x(config.sourceId, config);
    });
};
exports.update = update;
var Engine = /** @class */ (function () {
    function Engine(_a) {
        var _this = this;
        var _b = _a.state, state = _b === void 0 ? {} : _b, _c = _a.use, use = _c === void 0 ? [] : _c;
        this.modules = [];
        this.db = (0, engine_db_1.default)(state);
        use.forEach(function (x) {
            _this.use(x);
        });
        updateListeners.push(function (sourceId, config) {
            _this.modules.forEach(function (x) {
                x.update(sourceId, config);
            });
        });
    }
    Engine.prototype.state = function (state) {
        var _this = this;
        Object.entries(state).forEach(function (_a) {
            var x = _a[0], y = _a[1];
            _this.db.patch([{ op: "add", path: "/" + x, value: y }]);
        });
    };
    Engine.prototype.use = function (source) {
        var module = new module_1.EngineModule(this.db, source);
        this.modules.push(module);
    };
    Engine.prototype.start = function () {
        this.modules.forEach(function (x) {
            x.start();
        });
    };
    Engine.prototype.stop = function () {
        this.modules.forEach(function (x) {
            x.stop();
        });
    };
    return Engine;
}());
exports.Engine = Engine;
var engine = function (config) {
    return new Engine(config || {});
};
exports.engine = engine;
//# sourceMappingURL=data:application/json;base64,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